import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import { VideoPracticeSkillsRating } from 'redux/schemas/models/video-practice-skills-feedback';
import { VideoPracticeFeedbackActivity } from 'redux/schemas/models/video-practice-feedback';
import { ExerciseSkillsRatingActivity } from 'redux/schemas/models/exercise-skills-rating';

import NvIcon from 'shared/components/nv-icon';
import { CheckIcon, todoIcon, todoProgress } from './todo-row';
import ProgressIcon from '../progress-icon';
import ActivityDeadline from './activity-deadline';
import TodoThumbnail, { TodoThumbnailProps } from './todo-thumbnail';

type FeedbackTodoProps = (VideoPracticeSkillsRating | VideoPracticeFeedbackActivity | ExerciseSkillsRatingActivity) & TodoThumbnailProps;

function FeedbackTodo(props: FeedbackTodoProps) {
  const {
    type,
    title,
    progress,
    deadline,
    thumbnailSrc,
    backgroundColor,
  } = props;

  const deadlineMoment = moment(deadline);
  const currentMoment = moment();

  const isComplete = progress === todoProgress.COMPLETED;
  const inProgress = progress === todoProgress.IN_PROGRESS;
  const isNotStarted = progress === todoProgress.NOT_STARTED;
  const isMissed = progress === todoProgress.MISSED;

  const icon = todoIcon[type];
  const showTodoIcon = isNotStarted || isMissed;

  const showDueSoon = deadline
    && (inProgress || isNotStarted)
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    isComplete && 'completed',
    inProgress && 'in-progress',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <TodoThumbnail
          thumbnailSrc={thumbnailSrc}
          backgroundColor={backgroundColor}
        />
        <div className='todo-icon'>
          {showTodoIcon && <NvIcon icon={icon} size='smallest' />}
          {isComplete && <CheckIcon />}
          {inProgress && (
            <ProgressIcon>
              <NvIcon icon={icon} size='smallest' />
            </ProgressIcon>
          )}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isComplete && t.TIMELINE.EXERCISE_STATUS.SUBMITTED()}
          {inProgress && t.TIMELINE.EXERCISE_STATUS.IN_PROGRESS()}
          {isMissed && t.TIMELINE.EXERCISE_STATUS.MISSED()}
        </div>
        <ActivityDeadline deadline={deadline} />
      </div>
    </div>
  );
}

export default FeedbackTodo;
